import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocation, Link as ReactLink } from 'react-router-dom';
function Link({ to, children }) {
    const location = useLocation();
    const isSPAMode = location.pathname.includes('SPA.aspx');
    return (_jsxs(_Fragment, { children: [isSPAMode && _jsx(ReactLink, { to: `/SPA.aspx/${to}`, children: children }), !isSPAMode && _jsx(ReactLink, { to: to, children: children })] }));
}
export default Link;
